import React from 'react';
import { formatAxiosError } from '../../../utils/formatAxiosError';

export interface QueryErrorEntry {
    isError: boolean;
    error: unknown;
    title: string;
    refetch?: () => void;
}

interface QueryErrorAlertsProps {
    queries: QueryErrorEntry[];
}

const QueryErrorAlerts: React.FC<QueryErrorAlertsProps> = ({ queries }) => {
    const errors = queries.filter((q) => q.isError);

    if (errors.length === 0) return null;

    return (
        <>
            {errors.map((q, index) => {
                const { message, traceId } = formatAxiosError(q.error);

                return (
                    <div key={index} className="alert alert-important alert-danger alert-dismissible" role="alert">
                        <div className="alert-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon alert-icon icon-2">
                                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                                <path d="M12 8v4" />
                                <path d="M12 16h.01" />
                            </svg>
                        </div>
                        <div>
                            <span className="fw-bold">{q.title}</span>
                            <span className="ms-1 text-muted">— {message}</span>
                            {traceId && (
                                <span className="ms-2 text-muted small" title="Identifiant de trace">
                                    #{traceId}
                                </span>
                            )}
                        </div>
                        {q.refetch && (
                            <button type="button" className="alert-action btn btn-sm" onClick={q.refetch}>
                                Réessayer
                            </button>
                        )}
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="close" />
                    </div>
                );
            })}
        </>
    );
};

export default QueryErrorAlerts;
